import React from 'react';
import { Box } from '@mui/material';
import {
  ImportedLoadAttachment,
  LoadDocument,
  LoadPhoto
} from '../../../redux/api/load/load.model';
import { getFileName } from '../TwDocumentViewer';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';
import DateUtils from '../../../utils/dateUtils';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { AttachmentFile } from '../../../redux/api/otherExpenseAttachment/otherExpenseAttachment.model';

export interface TwPhotoMobileMenuHeaderProps {
  file: LoadDocument | LoadPhoto | ImportedLoadAttachment | AttachmentFile | null;
  fileSrc: string | null;
}

const TwPhotoMobileMenuHeader: React.FC<TwPhotoMobileMenuHeaderProps> = ({
  file,
  fileSrc
}): JSX.Element => {
  const checkIfImage = (): boolean => {
    let isImage = false;
    if (file && fileSrc) {
      if ('file_type' in file && file?.file_type?.includes('image')) {
        isImage = true;
      } else if ('content_type' in file && file?.content_type?.includes('image')) {
        isImage = true;
      }
    }
    return isImage;
  };

  const Preview = (): JSX.Element => {
    if (checkIfImage() && fileSrc) {
      return <Box component="img" src={fileSrc} height="40px" width="40px" />;
    }
    return <InsertDriveFileOutlinedIcon className="detail-file__adornment" />;
  };

  const FileType = (): JSX.Element => {
    return (
      <Typography variant="body2" fontWeight="400" fontSize="14px" color="#6B7280">
        {checkIfImage() ? 'Image' : 'PDF'}
      </Typography>
    );
  };

  const CreatedAgo = (): JSX.Element => {
    if (file && 'created_at' in file && !!file.created_at) {
      const createdAt = DateUtils.getDateInLocale(new Date(file.created_at));
      const daysAgo = DateUtils.getNumberOfDaysUntilNow(createdAt) || 0;

      if (daysAgo < 1) {
        return (
          <Typography variant="body2" fontWeight="400" fontSize="14px" color="#6B7280">
            • today
          </Typography>
        );
      }

      return (
        <Typography variant="body2" fontWeight="400" fontSize="14px" color="#6B7280">
          • {daysAgo} day{daysAgo > 1 ? 's' : ''} ago
        </Typography>
      );
    }
    return <></>;
  };

  const UploadedBy = (): JSX.Element => {
    if (file && 'uploaded_by' in file) {
      return (
        <Typography variant="body2" fontWeight="400" fontSize="14px" color="#6B7280">
          by {file.uploaded_by}
        </Typography>
      );
    }
    return <></>;
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="flex-start"
      alignItems="center"
      sx={{ width: '100%', margin: '16px 0px 10px 16px' }}
    >
      <Preview />
      <Stack
        direction="column"
        spacing={1}
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ width: '100%' }}
      >
        <Typography variant="body2" fontWeight="500" fontSize="14px" color="#1F2937">
          {getFileName(file)}
        </Typography>

        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-start"
          alignItems="center"
          sx={{ width: '100%' }}
        >
          <FileType /> <CreatedAgo /> <UploadedBy />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TwPhotoMobileMenuHeader;
